import { DEFAULT_REPORT_BLOCK_IDS, tabNames } from '@va/constants';
import { PageContent } from '@va/dashboard/shared/ui-layout';
import { useActiveTab, usePageHeaderProps } from '@va/dashboard/util-hooks';
import { useRefreshContext } from '@va/util/components';
import { useMemo } from 'react';
import { LatestVisitorsTableReport } from './LatestVisitorsTableReport';

export const LatestVisitorsTab = () => {
  useActiveTab(tabNames.latestVisitorsList);

  const { manualRefresh } = useRefreshContext();

  const pageHeaderProps = useMemo(
    () => ({
      refreshFn: () => {
        manualRefresh();
      },
    }),
    [manualRefresh],
  );

  usePageHeaderProps(pageHeaderProps);

  return (
    <PageContent>
      <LatestVisitorsTableReport id={DEFAULT_REPORT_BLOCK_IDS.latestVisitorsTable} />
    </PageContent>
  );
};
